import { Field, Form } from "formik";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toastr } from "react-redux-toastr";
import ReactSelect from "react-select";
import { BeatLoader } from "react-spinners";
import { Col, FormGroup, Input, Label, Row } from "reactstrap";
import { useDropzone } from "react-dropzone";
import Resizer from "react-image-file-resizer";
import { api } from "../../api/api";
import { lookupItems, voicePackageRow } from "../voiceAdd/openForm";
import { ComonIcons } from "../../contents/commonIcons";
import { ProfilePicture } from "../../contents/htmlContent";
import {
  getAppointmentTypes,
  getCourtDurations,
  getCourts,
  getPackages,
  getPayRates,
  getPayRatesType,
  getTrainers,
} from "../../redux/actions/api/apiAction";
import { CheckBox } from "../checkBox";
import MultiSelector from "../multiSelector";
import { ValidationError } from "../validationError";
import { FormatObjects } from "./bookAppointment/utils";
import { checkIfAlreadyExist, customStyle, defaultSettings } from "./utils";
import { store } from "../../redux/storeConfig/store";

const DropZone = ({ setFieldValue }) => {
  const onDrop = useCallback((acceptedFiles) => {
    let file = acceptedFiles[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = async () => {
        Resizer.imageFileResizer(
          file,
          300,
          300,
          "PNG",
          100,
          0,
          async (uri) => {
            let data = {
              fileName: acceptedFiles[0].name,
              source: uri,
              folder: "profile",
            };
            var url = await api(`file`, data, "post");
            if (url.data.status === 201) {
              setFieldValue("image", url.data.data);
            }
          },
          "base64",
          300,
          300
        );
      };
      reader.readAsDataURL(file);
    }
  }, [setFieldValue]);
  const { getRootProps, getInputProps } = useDropzone({
    onDrop,
    minSize: 0,
    maxSize: 10485760,
    accept: "image/*",
  });
  return (
    <div className="upload-profilephoto">
      <div className="file-input" {...getRootProps()}>
        <h6 className="upload-link mb-0">Upload Picture </h6>
        <input {...getInputProps()} />
      </div>
    </div>
  );
};

export const AppointmentForm = (formikProps) => {
  const { trainers } = useSelector((state) => state.trainer);
  const { gym, gymConfig } = useSelector((state) => state.gym);
  const { gymFeaturesObject } = useSelector((state) => state.features);

  const { courtDurations, courts } = store.getState().court;
  console.log({ courts });
  courtDurations.forEach((d) => (d.name = `${d.duration} mins`));

  const durationsList = useMemo(
    () => FormatObjects(courtDurations, "name", false, "duration"),
    [courtDurations]
  );
  const payRatesType = useSelector((state) => state.payRoll.payRatesType);
  const payRates = useSelector((state) => state.payRoll.payRates);

  const courtsList = React.useMemo(() => FormatObjects(courts, "name"), [
    courts,
  ]);
  const [payRatesSelected, setPayRatesSelected] = useState([]);
  const [payRatesRender, setPayRatesRender] = useState([]);
  const [selectedPayRateType, setSelectedPayRateType] = useState("");
  const [selectedPayRate, setSelectedPayRate] = useState("");
  const [isPayRatesSelected, setIsPayRatesSelected] = useState(false);
  console.log({ values: formikProps.values });
  const checkDuration = (timeSlots, targetDuration) => {
    for (const day in timeSlots) {
      if (
        timeSlots[day].some((slot) => parseInt(slot.duration) >= targetDuration)
      ) {
        return true;
      }
    }
    return false;
  };

  const getCourtTimeSlots = (id) => {
    // Find the selected court
    const selectedCourt = courts.find((court) => court.id == id);
    if (!selectedCourt) {
      return {}; // or handle the case when the court is not found
    }

    // Gather all timeSlots from each dateInterval
    const gatheredTimeSlots = selectedCourt.dateIntervals.reduce(
      (acc, interval) => {
        for (const [day, slots] of Object.entries(interval.timeSlots)) {
          if (!acc[day]) {
            acc[day] = [];
          }
          acc[day] = acc[day].concat(slots);
        }
        return acc;
      },
      {}
    );
    console.log({ gatheredTimeSlots });
    return gatheredTimeSlots;
  };

  const { packages, appointmentTypes } = useSelector((state) => state.packages);
  const [updatedPackages, setUpdatedPackages] = React.useState(packages);
  const dispatch = useDispatch();
  let trainersData = useMemo(() => FormatObjects(trainers, "user_name"), [
    trainers,
  ]);
  let packagesData = useMemo(() => {
    let formatedObjects = FormatObjects(updatedPackages, "name");
    return formatedObjects.map((obj, idx) => {
      return {
        ...obj,
        price: updatedPackages[idx].price,
        sessionCount: updatedPackages[idx].sessionCount,
        appointments: updatedPackages[idx].appointments,
      };
    });
  }, [updatedPackages]);
  const voicePrefill = useSelector((state) => state.voiceAdd && state.voiceAdd.prefill);
  const voiceDrafts = useSelector(
    (state) => (state.voiceAdd && state.voiceAdd.drafts) || []
  );
  const voiceAppointmentApplied = React.useRef(false);
  const voiceAppointmentKey =
    voicePrefill && voicePrefill.type === "appointment" ? voicePrefill.id : "";
  React.useEffect(() => {
    voiceAppointmentApplied.current = false;
  }, [voiceAppointmentKey]);
  React.useEffect(() => {
    if (voiceAppointmentApplied.current) return;
    if (!voicePrefill || voicePrefill.type !== "appointment") return;
    const trainerRefs = lookupItems(voicePrefill.fields && voicePrefill.fields.trainers);
    const packRefs = lookupItems(voicePrefill.fields && voicePrefill.fields.packages);
    if (trainerRefs.length && !trainersData.length) {
      return;
    }
    if (trainerRefs.length) {
      const chosen = trainersData.filter((item) =>
        trainerRefs.some(
          (ref) => String(ref.id || ref.value) === String(item.value)
        )
      );
      if (chosen.length) formikProps.setFieldValue("trainers", chosen);
    }
    if (packRefs.length) {
      const chosen = packRefs.map((ref) => {
        const known = packagesData.find(
          (item) =>
            String(item.value) === String(ref.id || ref.value || ref.pending)
        );
        if (known) return { ...known, count: ref.count || 1 };
        const row = voicePackageRow(ref, voiceDrafts);
        return {
          ...row,
          value: row.id,
          key: row.id,
        };
      });
      if (chosen.length) formikProps.setFieldValue("packages", chosen);
    }
    voiceAppointmentApplied.current = true;
  }, [voicePrefill, trainersData, packagesData, voiceDrafts]);
  const types = FormatObjects(appointmentTypes, "name");

  React.useEffect(() => {
    setUpdatedPackages(
      packages.filter((p) => {
        console.log({ p: p.isSold });
        return (
          !p.isSold &&
          (p.appointments == null ||
            !p.appointments.length ||
            p.appointments.reduce((sum, obj) => sum + obj.count, 0) <
              p.sessionCount)
        );
      })
    );
  }, [packages]);
  React.useEffect(() => {
    dispatch(getCourtDurations());
    dispatch(getAppointmentTypes());
    dispatch(getCourts());

    dispatch(
      getTrainers(
        1,
        10000,
        JSON.parse(localStorage.getItem("connectToFitGymPanelUser")).gym,
        "",
        "",
        "Y",
        "pt"
      )
    );
    dispatch(getPackages(1, 100000, true, undefined, undefined, "pt"));
  }, []);

  const handleRemovePack = (idx, pack) => {
    const selectedPacks = formikProps.values.packages
      .map((_pack) => _pack)
      .filter((_pack) => pack.value != _pack.value);
    formikProps.setFieldValue("packages", selectedPacks);
  };

  const handleAddPack = (pack) => {
    const canAdd = !checkIfAlreadyExist(
      formikProps.values.packages,
      pack.value
    );
    if (canAdd)
      formikProps.setFieldValue("packages", [
        ...formikProps.values.packages,
        pack,
      ]);
    else toastr.error("Already assigned");
  };

  useEffect(() => {
    console.log(
      formikProps?.values?.duration,
      formikProps.values?.court,
      getCourtTimeSlots(formikProps.values?.court)
    );
    if (formikProps?.values?.duration && formikProps.values?.court) {
      if (
        !checkDuration(
          getCourtTimeSlots(formikProps.values?.court),
          formikProps.values?.duration
        )
      ) {
        formikProps.setFieldValue("duration", "");
        toastr.error("The duration is out of court schedule");
      }
    }
  }, [formikProps?.values?.duration]);
  React.useEffect(() => {
    dispatch(getPayRatesType());
  }, [dispatch]);
  const handlePayRateTypesChange = (e) => {
    console.log(e.target.value, "e.target.value");
    setSelectedPayRateType(e.target.value);
    dispatch(getPayRates(e.target.value));
  };
  const handlePayRateChange = async (e) => {
    const selectedId = parseInt(e.target.value, 10);
    setSelectedPayRate(e.target.value);

    if (!payRatesSelected) {
      setIsPayRatesSelected(false);
    }

    const selectedPayRate = payRates.find(
      (payRate) => payRate.id === selectedId
    );
    if (
      selectedPayRate &&
      !payRatesSelected.some((payRate) => payRate.id === selectedId)
    ) {
      setPayRatesSelected(() => {
        const updatedPayRatesSelected = [selectedPayRate];

        // Move the setFieldValue call inside this callback to ensure it uses updated state
        formikProps.setFieldValue("payRates", updatedPayRatesSelected);
        return updatedPayRatesSelected; // This returns the new state
      });
    } else {
      console.log("Pay rate already selected or not found");
    }
  };
  return (
    <>
      {trainersData ? (
        <Form id="add-appointment">
          <div className="profile-image-block blk-padding-y border-bottom-1 mb-4">
            <div className="profile-image-inner-block d-flex justify-content-center">
              <div className="profile-image-wrapper">
                <div className="profile-image">
                  <img
                    src={
                      formikProps.values.image
                        ? formikProps.values.image
                        : require("../../assets/images/no-image_user.jpg")
                    }
                    className="img-fluid img-blk"
                    alt="appointment"
                  />
                </div>
                <div className="profile-image-links">
                  <div className="links file-input-link">
                    <div className="file-input">
                      <DropZone setFieldValue={formikProps.setFieldValue} />
                    </div>
                  </div>
                  <div className="links">
                    <h6
                      className="remove-link mb-0 text-uppercase"
                      onClick={() => {
                        if (formikProps.values.image) {
                          formikProps.setFieldValue("image", "");
                        }
                      }}
                    >
                      {ProfilePicture.removePicture}{" "}
                    </h6>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Row className={"border-bottom-1 pb-4"}>
            <Col md={6} className="pl-0 mb-4 no-margin-on-mobile">
              <FormGroup
                className="custom-inputs select-box mb-md-0 custom-add-sale-input"
                style={{ height: "52px" }}
              >
                <Input
                  type="text"
                  name="name"
                  className={`${formikProps.errors.name &&
                    formikProps.touched.name &&
                    "is-invalid"}`}
                  value={formikProps.values.name}
                  onChange={formikProps.handleChange}
                  placeholder="Start typing..."
                />
                <Label for="name">Name</Label>
              </FormGroup>
              <ValidationError
                errors={formikProps.errors}
                touched={formikProps.touched}
                propName={"name"}
              />
            </Col>
            <Col md={6} className="pl-0 mb-4 no-margin-on-mobile">
              <FormGroup
                className="custom-inputs select-box mb-md-0 custom-add-sale-input"
                style={{ height: "52px" }}
              >
                <Input
                  type="text"
                  name="displayName"
                  maxLength={50}
                  className={`${formikProps.errors.displayName &&
                    formikProps.touched.displayName &&
                    "is-invalid"}`}
                  value={formikProps.values.displayName}
                  onChange={formikProps.handleChange}
                  placeholder="Start typing..."
                />
                <Label for="displayName">Display Name (Mobile App)</Label>
              </FormGroup>
              <ValidationError
                errors={formikProps.errors}
                touched={formikProps.touched}
                propName={"displayName"}
              />
            </Col>
            <Col md={6} className="pl-0 mb-4 no-margin-on-mobile">
              {gym?.type == "sportClub" ? (
                <FormGroup className="custom-inputs select-box mb-md-0">
                  <Input
                    type="select"
                    value={formikProps?.values?.duration}
                    onChange={(e) =>
                      formikProps.setFieldValue("duration", e.target.value)
                    }
                    placeholder="Minutes"
                    id={"duration"}
                    name="duration"
                    className={`form-control input ${formikProps.errors
                      .duration &&
                      formikProps.touched.duration &&
                      "is-invalid"}`}
                  >
                    <option key={null} value={""}>
                      Select Duration{" "}
                    </option>
                    {durationsList.map((d) => (
                      <option key={d.value} value={d.value}>
                        {d.label}
                      </option>
                    ))}
                  </Input>
                  {formikProps.errors.duration &&
                  formikProps.touched.duration ? (
                    <div className="invalid-feedback d-block">{`${formikProps.errors.duration}`}</div>
                  ) : null}
                  <Label for="from" className="">
                    {"Duration"}
                  </Label>
                </FormGroup>
              ) : (
                <FormGroup className="custom-inputs select-box mb-md-0">
                  <Field
                    type="number"
                    selected={formikProps.duration}
                    placeholder="Minutes"
                    id={"duration"}
                    name="duration"
                    className={`form-control input ${formikProps.errors
                      .duration &&
                      formikProps.touched.duration &&
                      "is-invalid"}`}
                  />
                  {formikProps.errors.duration &&
                  formikProps.touched.duration ? (
                    <div className="invalid-feedback d-block">{`${formikProps.errors.duration}`}</div>
                  ) : null}
                  <Label for="from" className="">
                    {"Duration"}
                  </Label>
                </FormGroup>
              )}
            </Col>

            {gymConfig?.payroll?.enabled && (
              <>
                {" "}
                <Col md={3} className="pl-0 mb-4 no-margin-on-mobile">
                  <FormGroup className="custom-inputs mb-md-0">
                    <Field
                      onChange={handlePayRateTypesChange}
                      // required={payRatesSelected.length < 1}
                      value={selectedPayRateType}
                      as="select"
                      name="payratesType"
                      id="payratesType"
                      className={`form-control ${payRatesSelected.length < 1 &&
                        isPayRatesSelected &&
                        "is-invalid"}`}
                    >
                      <option value="">Select an option</option>
                      {payRatesType.length &&
                        payRatesType.map((type) => {
                          return <option value={type.id}>{type.name}</option>;
                        })}
                    </Field>
                    <Label>Main pay rate type</Label>
                  </FormGroup>
                </Col>
                <Col md={3} className="pl-0 mb-4 no-margin-on-mobile">
                  <FormGroup className="custom-inputs mb-md-0">
                    <Field
                      onChange={handlePayRateChange}
                      required={payRatesSelected.length}
                      value={selectedPayRate}
                      as="select"
                      name="payrate"
                      id="payrate"
                      className={`form-control ${payRatesSelected.length < 1 &&
                        isPayRatesSelected &&
                        "is-invalid"}`}
                    >
                      <option value="">Select an option</option>
                      {payRates &&
                        payRates.map((payRate) => {
                          return (
                            <option value={payRate.id}>
                              {payRate.payrateName}
                            </option>
                          );
                        })}
                    </Field>
                    {payRatesSelected.length < 1 && isPayRatesSelected ? (
                      <div className="invalid-feedback">
                        Please select at least one pay rate
                      </div>
                    ) : null}
                    <Label>Sub pay rate type</Label>
                  </FormGroup>
                </Col>
              </>
            )}

            {gym.type == "sportClub" && (
              // <Col md={6} className="pl-0 mb-4 no-margin-on-mobile">
              //   <FormGroup className="custom-inputs select-box mb-md-0">
              //     <Input
              //       type="select"
              //       selected={formikProps.duration}
              //       disabled={!formikProps?.values?.duration}
              //       onChange={(e) => {
              //         formikProps.setFieldValue(
              //           "court",
              //           parseInt(e.target.value)
              //         );
              //         let timeSlots = getCourtTimeSlots(e.target.value);
              //         if (
              //           !checkDuration(timeSlots, formikProps.values.duration)
              //         ) {
              //           formikProps.setFieldValue("duration", "");

              //           return toastr.error(
              //             "The duration is out of court schedule"
              //           );
              //         }
              //       }}
              //       placeholder="Minutes"
              //       id={"court"}
              //       name="court"
              //       className={`form-control input ${formikProps.errors
              //         .duration &&
              //         formikProps.touched.duration &&
              //         "is-invalid"}`}
              //     >
              //       <option key={null} value={null}>
              //         Select Court{" "}
              //       </option>
              //       {courtsList.map((d) => (
              //         <option key={d.value} value={d.value}>
              //           {d.label}
              //         </option>
              //       ))}
              //     </Input>
              //     {formikProps.errors.duration &&
              //     formikProps.touched.duration ? (
              //       <div className="invalid-feedback d-block">{`${formikProps.errors.duration}`}</div>
              //     ) : null}
              //     <Label for="from" className="">
              //       {"court"}
              //     </Label>
              //   </FormGroup>
              // </Col>
                <Col md={6} className="pl-0 mb-4 no-margin-on-mobile">
                <FormGroup className="custom-inputs select-box mb-md-0">
                 <Input
                    type="select"
                    name="coachingType"
                    id="coachingType"
                    placeholder={"Coaching type"}
                    className={`form-control`}
                    onChange={(e) => {
                      formikProps.setFieldValue(
                        "coachingType",
                        e.target.value
                      );
                    }}
                  >
                    <option value="">No Prefrence</option>
                    <option value="tennis">Tennis</option>
                    <option value="padel">Padel</option>
                    <option value="football">Football</option>
                    <option value="basketball">Basketball</option>
                      <option value="pickleball">Pickleball</option>
                      <option value="tableTennis">Table Tennis</option>

                </Input>
                  <Label for="from" className="">
                    {"Coaching Type"}
                  </Label>
                </FormGroup>
              </Col>
            )}
            <Col md={3} className="pl-0 mb-4 no-margin-on-mobile">
              <FormGroup className="custom-inputs mb-md-0 selected-package-start-date-container ">
                <ReactSelect
                  // isMulti
                  name="appointmentType"
                  options={types}
                  className="form-control custom-inputs p-0 h-100 d-flex align-items-center"
                  styles={customStyle}
                  values={formikProps.values.appointmentType}
                  onChange={(type) => {
                    if (type) {
                      formikProps.setFieldValue("appointmentType", type);
                    } else {
                      formikProps.setFieldValue("appointmentType", null);
                    }
                  }}
                />
                <Label for="appointmentType">Appointment Type</Label>
              </FormGroup>
            </Col>
            <Col md={3} className="pl-0 mb-4 no-margin-on-mobile">
              <FormGroup className="custom-inputs mb-md-0 selected-package-start-date-container ">
                <Input
                  type="number"
                  className={`${formikProps.errors.price &&
                    formikProps.touched.price &&
                    "is-invalid"}`}
                  placeholder="Start typing..."
                  value={formikProps.values.price}
                  name="price"
                  onChange={formikProps.handleChange}
                />
                <Label for="price">Price for single session</Label>
              </FormGroup>
            </Col>
            <Col md={12} className={" pl-0"}>
              <FormGroup className="custom-inputs mb-md-0 ">
                <MultiSelector
                  name="trainers"
                  data={trainersData}
                  handleChange={formikProps.setFieldValue}
                  values={formikProps.values.trainers}
                />
                <Label for="assignableTrainer">
                  {gym.type == "sportClub"
                    ? "Assignable Coaches"
                    : gym.type == "complex"
                    ? "Assignable Instructor"
                    : "Assignable Trainers"}
                </Label>
              </FormGroup>
            </Col>
            <Col md={12} className={"px-0 pt-5 pt-mob-3 border-top-1"}>
              <h4 className="mb-4">Packages</h4>
              <FormGroup className="custom-inputs mb-md-0 ">
                <ReactSelect
                  // isMulti
                  name="packages"
                  options={packagesData}
                  className="form-control custom-inputs p-0 h-100 d-flex align-items-center"
                  styles={customStyle}
                  values={formikProps.values.packages}
                  onChange={(pack) => handleAddPack(pack)}
                />
                <Label for="packages">Assign To</Label>
              </FormGroup>
            </Col>
            {(formikProps.values.packages || []).length ? (
              <div className="w-100 selected-classes-box scroll-y  max-height-150 pr-0">
                {(formikProps.values.packages || []).map((pack, idx) => {
                  return (
                    <Row
                      className="selected-class-row py-2 w-100"
                      key={pack.key}
                    >
                      <Col
                        md={3}
                        className="selected-class-name d-inline-flex align-items-center justify-content-start"
                      >
                        <p>{pack.label}</p>
                      </Col>
                      <Col
                        md={2}
                        className="selected-class-name d-inline-flex align-items-center justify-content-start"
                      >
                        <p>
                          {pack.price}{" "}
                          {
                            JSON.parse(
                              localStorage.getItem("connectToFitGymPanelUser")
                            ).currency
                          }
                        </p>
                      </Col>
                      <Col
                        md={3}
                        className="selected-class-name d-inline-flex align-items-center justify-content-start"
                      >
                        <p>
                          {pack.sessionCount} Sessions/{" "}
                          {(pack && pack.appointments && pack.appointments.length)
                            ? pack.sessionCount -
                              pack.appointments.reduce(
                                (sum, obj) => sum + obj.count,
                                0
                              )
                            : 0}{" "}
                          used
                        </p>
                      </Col>
                      <Col md={3}>
                        <Input
                          type="number"
                          placeholder="Count..."
                          name={`packages[${idx}].count`}
                          value={
                            formikProps.values.packages[idx] &&
                            formikProps.values.packages[idx].count
                          }
                          onChange={formikProps.handleChange}
                          maxLength={
                            pack && pack.appointments && pack.appointments.length
                              ? pack.sessionCount -
                                pack.appointments.reduce(
                                  (sum, obj) => sum + obj.count,
                                  0
                                )
                              : pack && pack.sessionCount
                          }
                        />
                      </Col>
                      <Col
                        md={1}
                        className="d-inline-flex align-items-center justify-content-start"
                        onClick={(idx) => handleRemovePack(idx, pack)}
                      >
                        {ComonIcons.delete}
                      </Col>
                    </Row>
                  );
                })}
              </div>
            ) : (
              <div className="w-100 selected-classes-box">
                <h4 className="my-auto">No Packages Selected</h4>
              </div>
            )}
            <Col
              md={12}
              className="mt-4 pl-0 border-top-1 border-bottom-1 py-2"
            >
              {defaultSettings.map((setting, idx) => {
                return (
                  <CheckBox
                    name={`${defaultSettings[idx].label}`}
                    propName={`${setting.key}`}
                    isChecked={formikProps.values[`${setting.key}`]}
                    handleChange={formikProps.handleChange}
                    onSeperateLine
                  />
                );
              })}
            </Col>
            <Col md={12} className="pl-0 pt-4">
              <FormGroup className="custom-inputs pl-0 mb-0">
                <Input
                  type="textarea"
                  rows="3"
                  style={{ height: "128px" }}
                  name="description"
                  className={`${formikProps.errors.description &&
                    formikProps.touched.description &&
                    "is-invalid"}`}
                  placeholder="Start typing..."
                  onChange={formikProps.handleChange}
                  value={formikProps.values.description}
                />
                <Label for="description">Description</Label>
              </FormGroup>
            </Col>
          </Row>
        </Form>
      ) : (
        <div className="beat-loader h-100 w-100">
          <BeatLoader />
          <p>Please Wait ...</p>
        </div>
      )}
    </>
  );
};

/*
[
    {
        "date": "03/15/2023",
        "schedules": []
    },
    {
        "date": "03/16/2023",
        "schedules": [
            {
                "type": "class",
                "noBookings": 0,
                "trainer": "Sameeh Janakat",
                "name": "Tue, Thur Class",
                "id": 6373,
                "startDate": 1678868447160,
                "endDate": 1679386847000,
                "from": "1678959000000",
                "to": "1678962600000"
            }
        ]
    },
    {
        "date": "03/17/2023",
        "schedules": []
    },
    {
        "date": "03/18/2023",
        "schedules": []
    },
    {
        "date": "03/19/2023",
        "schedules": []
    },
    {
        "date": "03/20/2023",
        "schedules": []
    },
    {
        "date": "03/21/2023",
        "schedules": []
    }
]




*/
